export enum QuestionType {
  I2IChargesScreen = 'i2iChargesScreen',
  I2IProviderOnboardingExplanationScreen = 'i2iProviderOnboardingExplanationScreen',
  PracticeSummaryInformationScreen = 'practiceSummaryInformationScreen',
  Password = 'password',
}
